// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::host::ng-deep body {
  overflow: hidden !important;
}

.fixed-toolbar {
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #eaeaea;
  box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  position: fixed;
  left: 240px;
  right: 0;
  padding-left: 20px;
  z-index: 5;
  height: 50px;
}

.breadcrumb-container {
  margin-right: 10px;
  max-height: 100%;
}

.toolbar {
  align-items: center;
}

.fixed-toolbar ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.example-container {
  display: flex;
  flex-direction: column;
}

.example-container > * {
  width: 25%;
}

.menu > li {
  float: left;
}

.menu > li + li {
  margin-left: 1em;
}

.menu > li > a {
  border: 1px solid #bdc3c7;
  border-radius: 2px;
  cursor: pointer;
  display: block;
  padding: 5px 1em;
  position: relative;
  white-space: nowrap;
}

.menu > li > a:hover {
  background-color: #f7f7f7;
  color: #3d464d;
  text-decoration: none;
}

.toolbar .dropdown.open > a {
  background-color: #ebebeb;
  border-color: #bdc3c7;
}

.menu > li > a > i {
  font-size: 16px;
  margin-right: 10px;
}

.menu button {
  padding: 0 12px;
}

.menu button.mat-primary {
  line-height: 30px;
}

.menu button:not(.mat-primary) {
  border: 1px solid #bdc3c7;
  line-height: 28px;
}

.menu button i {
  font-size: 16px;
  margin-right: 10px;
}

#btn-del-form {
  margin-right: 10px;
}

.contact-list {
  margin: 50px 10px 10px;
  width: 98%;
  position: relative;
  transition: background-color 0.3s, opacity 0.3s;
}

.div-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  min-height: 64px;
}

.mat-form-field {
  width: 200px;
  justify-content: flex-start;
  margin-right: 30px;
  font-size: 14px;
}

.div-container {
  display: flex;
  flex-direction: column;
  /*max-height: 310px;*/
  min-width: 300px;
  position: relative;
}

.actions {
  display: flex;
  justify-content: flex-end;
}

.table-list {
  overflow: auto;
  height: calc(100vh - 180px);
}

.mat-column-select {
  overflow: visible;
}

::ng-deep mat-cell, mat-footer-cell, mat-header-cell {
  flex: 1;
  display: unset !important;
  align-items: center;
  overflow: hidden;
  word-wrap: break-word;
  min-height: unset !important;
}

.col-menu {
  flex: 0 0 5% !important;
}

.fixed-toolbar {
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #eaeaea;
  box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  position: fixed;
  left: 240px;
  top: 50px;
  height: 50px;
  right: 0;
  padding: 0 20px;
  z-index: 5;
}

.fixed-toolbar ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.breadcrumb-container {
  margin-right: 10px;
  max-height: 100%;
}

.breadcrumb-container h1 {
  font-size: 18px;
  font-weight: normal;
  margin: 0;
}

.flex-container {
  display: flex;
  flex-direction: row;
}

.mat-form-field {
  width: 700px;
}

.fitter {
  flex-grow: 7;
  padding-left: 24px;
}

.form-list {
  margin: 50px 10px 10px;
  width: 98%;
  transition: background-color 0.3s, opacity 0.3s;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  position: relative;
}

.paginator {
  float: right;
}

td.mat-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 200px;
  overflow: hidden;
}

.app-tasklist {
  margin: 50px 20px 20px;
  position: relative;
  transition: background-color 0.3s, opacity 0.3s;
}

.empty-folder {
  flex-direction: column;
  margin-right: 2em;
  text-align: center;
}

.empty-folder img {
  width: 150px;
  height: 150px;
  opacity: 0.6;
  filter: grayscale(10%);
}

.empty-folder h4 {
  font-size: 20px;
  margin: 0 0 10px;
}

.mat-table tr.mat-header-row {
  height: 45px;
}

th.mat-header-cell .mat-sort-header-container.mat-sort-header-sorted .mat-sort-header-arrow {
  opacity: 1 !important;
  transform: translateY(0) !important;
}

.file-upload {
  display: none;
  overflow: hidden;
  width: 0;
  height: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/pdf-template-list/pdf-template-list.component.scss"],"names":[],"mappings":"AAAA;EACG,2BAAA;AACH;;AAEA;EACG,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8CAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AACH;;AAEA;EACG,kBAAA;EACA,gBAAA;AACH;;AAEA;EACG,mBAAA;AACH;;AAEA;EACG,gBAAA;EACA,SAAA;EACA,UAAA;AACH;;AAEA;EACG,aAAA;EACA,sBAAA;AACH;;AAEA;EACG,UAAA;AACH;;AAEA;EACG,WAAA;AACH;;AAEA;EACG,gBAAA;AACH;;AAEA;EACG,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AACH;;AAEA;EACG,yBAAA;EACA,cAAA;EACA,qBAAA;AACH;;AAEA;EACG,yBAAA;EACA,qBAAA;AACH;;AAEA;EACG,eAAA;EACA,kBAAA;AACH;;AAEA;EACG,eAAA;AACH;;AAEA;EACG,iBAAA;AACH;;AAEA;EACG,yBAAA;EACA,iBAAA;AACH;;AAEA;EACG,eAAA;EACA,kBAAA;AACH;;AAEA;EACG,kBAAA;AACH;;AAEA;EACG,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,+CAAA;AACH;;AAEA;EACG,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AACH;;AAEA;EACG,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;AACH;;AAEA;EACG,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AACH;;AAEA;EACG,aAAA;EACA,yBAAA;AACH;;AAEA;EACG,cAAA;EACA,2BAAA;AACH;;AAEA;EACG,iBAAA;AACH;;AAEA;EACG,OAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;AACH;;AAEA;EACG,uBAAA;AACH;;AAEA;EACG,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8CAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;AACH;;AAEA;EACG,gBAAA;EACA,SAAA;EACA,UAAA;AACH;;AAEA;EACG,kBAAA;EACA,gBAAA;AACH;;AAEA;EACG,eAAA;EACA,mBAAA;EACA,SAAA;AACH;;AAEA;EACG,aAAA;EACA,mBAAA;AACH;;AACA;EACG,YAAA;AAEH;;AACA;EACG,YAAA;EACA,kBAAA;AAEH;;AACA;EACG,sBAAA;EACA,UAAA;EACA,+CAAA;EAEA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;AACH;;AAEA;EACG,YAAA;AACH;;AAEA;EACG,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AACH;;AAEA;EACG,sBAAA;EACA,kBAAA;EACA,+CAAA;AACH;;AAEA;EACG,sBAAA;EACA,iBAAA;EACA,kBAAA;AACH;;AAEA;EACG,YAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;AACH;;AAEA;EACG,eAAA;EACA,gBAAA;AACH;;AAEA;EACG,YAAA;AACH;;AACA;EACG,qBAAA;EACA,mCAAA;AAEH;;AAAA;EACG,aAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;AAGH","sourcesContent":["::host::ng-deep body {\n   overflow: hidden !important;\n}\n\n.fixed-toolbar {\n   align-items: center;\n   background-color: #fff;\n   border-bottom: 1px solid #eaeaea;\n   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n   position: fixed;\n   left: 240px;\n   right: 0;\n   padding-left: 20px;\n   z-index: 5;\n   height: 50px;\n}\n\n.breadcrumb-container {\n   margin-right: 10px;\n   max-height: 100%;\n}\n\n.toolbar {\n   align-items: center;\n}\n\n.fixed-toolbar ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.example-container {\n   display: flex;\n   flex-direction: column;\n}\n\n.example-container > * {\n   width: 25%;\n}\n\n.menu > li {\n   float: left;\n}\n\n.menu > li + li {\n   margin-left: 1em;\n}\n\n.menu > li > a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open > a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu > li > a > i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n#btn-del-form {\n   margin-right: 10px;\n}\n\n.contact-list {\n   margin: 50px 10px 10px;\n   width: 98%;\n   position: relative;\n   transition: background-color .3s, opacity .3s;\n}\n\n.div-header {\n   display: flex;\n   flex-direction: row;\n   align-items: center;\n   justify-content: flex-end;\n   min-height: 64px;\n}\n\n.mat-form-field {\n   width: 200px;\n   justify-content: flex-start;\n   margin-right: 30px;\n   font-size: 14px;\n}\n\n.div-container {\n   display: flex;\n   flex-direction: column;\n   /*max-height: 310px;*/\n   min-width: 300px;\n   position: relative;\n}\n\n.actions {\n   display: flex;\n   justify-content: flex-end;\n}\n\n.table-list {\n   overflow: auto;\n   height: calc( 100vh - 180px);\n}\n\n.mat-column-select {\n   overflow: visible;\n}\n\n::ng-deep mat-cell, mat-footer-cell, mat-header-cell {\n   flex: 1;\n   display: unset !important;\n   align-items: center;\n   overflow: hidden;\n   word-wrap: break-word;\n   min-height: unset !important;\n}\n\n.col-menu {\n   flex: 0 0 5% !important;\n}\n\n.fixed-toolbar {\n   align-items: center;\n   background-color: #fff;\n   border-bottom: 1px solid #eaeaea;\n   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);\n   position: fixed;\n   left: 240px;\n   top: 50px;\n   height: 50px;\n   right: 0;\n   padding: 0 20px;\n   z-index: 5;\n}\n\n.fixed-toolbar ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.breadcrumb-container {\n   margin-right: 10px;\n   max-height: 100%;\n}\n\n.breadcrumb-container h1 {\n   font-size: 18px;\n   font-weight: normal;\n   margin: 0;\n}\n\n.flex-container {\n   display: flex;\n   flex-direction: row;\n}\n.mat-form-field {\n   width: 700px;\n}\n\n.fitter {\n   flex-grow: 7;\n   padding-left: 24px;\n}\n\n.form-list {\n   margin: 50px 10px 10px;\n   width: 98%;\n   transition: background-color .3s, opacity .3s;\n\n   display: flex;\n   flex-direction: column;\n   flex: 1;\n   overflow: auto;\n   position: relative;\n}\n\n.paginator{\n   float: right;\n}\n\ntd.mat-cell{\n   white-space: nowrap;\n   text-overflow: ellipsis;\n   max-width: 200px;\n   overflow: hidden;\n}\n\n.app-tasklist {\n   margin: 50px 20px 20px;\n   position: relative;\n   transition: background-color .3s, opacity .3s;\n}\n\n.empty-folder {\n   flex-direction: column;\n   margin-right: 2em;\n   text-align: center;\n}\n\n.empty-folder img {\n   width: 150px;\n   height: 150px;\n   opacity: .6;\n   filter: grayscale(10%);\n}\n\n.empty-folder h4 {\n   font-size: 20px;\n   margin: 0 0 10px;\n}\n\n.mat-table tr.mat-header-row {\n   height: 45px;\n}\nth.mat-header-cell .mat-sort-header-container.mat-sort-header-sorted .mat-sort-header-arrow {\n   opacity: 1 !important;\n   transform: translateY(0) !important;\n}\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
